export default __webpack_public_path__ + "static/home-kubernetes-4cfcb0a6c63d60d8e2ec48b933984b3c.svg";